import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import utils from '@/utils/tools.js'
import moment from "moment";

import login from '@/components/login/login.js';
import register from '@/components/login/register';
import RegisterSuccess from '@/components/login/RegisterSuccess';
import forgotpwd from '@/components/login/forgotpwd';

import Empty from '@/components/Empty.vue'
import GlobalSearch from '@/components/GlobalSearch.vue'
//頭部導航欄
import Navbar from '@/components/Navbar.vue';
//底部
import Footer from '@/components/Footer.vue';
//廣告內容
import Advertisement from '@/components/Advertisement.vue';



Vue.prototype.$login = login;
Vue.prototype.$register = register;
Vue.prototype.$forgotpwd = forgotpwd;
Vue.prototype.$RegisterSuccess = RegisterSuccess;
Vue.prototype.$utils = utils;
Vue.prototype.$moment = moment;




Vue.use(VueAwesomeSwiper)

Vue.component('list-empty', Empty)
Vue.component('GlobalSearch', GlobalSearch)
Vue.component('list-empty', Empty)
Vue.component('Navbar', Navbar)
Vue.component('Footer', Footer)
Vue.component('Advertisement', Advertisement)
//Vue.component('page-header', PageHeader)

Vue.config.productionTip = false


Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
